import {
  fetchClient
} from "./chunk-AQVZKKZU.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/events/tickets.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
function getTickets(_0) {
  return __async(this, arguments, function* ({
    slug,
    lang,
    perPage,
    page,
    ticketType = "event"
  }) {
    var _a, _b;
    try {
      const search = new URLSearchParams();
      search.append("lang", getLocaleOnly(lang));
      search.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
      if (page)
        search.append("page", page.toString());
      if (perPage)
        search.append("per_page", perPage.toString());
      const url = ticketType === "event" ? `/event-ticket-details/${slug}?${search.toString()}` : `/season-ticket-details/${slug}?${search.toString()}`;
      return yield fetchClient({
        url,
        includeAuth: false
      });
    } catch (error) {
      throw new Exception({
        error,
        name: ticketType === "event" ? "getEventTicketsException" : "getSeasonTicketsException"
      });
    }
  });
}

export {
  getTickets
};
//# sourceMappingURL=chunk-H2CYOPFA.mjs.map